import { Component, OnInit } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { MyEventsProvider } from '../../providers/my-events/my-events';
import { GeoFenceProvider } from './../../providers/geo-fence/geo-fence';
import { CurrentEventProvider } from '../../providers/current-event/current-event';

/**
 * Generated class for the MyEventsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'my-events',
  templateUrl: 'my-events.html',
})
export class MyEventsComponent implements OnInit {
  myEvents: Array<Event> = new Array<Event>();
  futureEvents: Array<Event> = new Array<Event>();
  pastEvents: Array<Event> = new Array<Event>();
  activeEvent: any[] = [];
  joinedEvents: any[];

  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private myEventsProvider: MyEventsProvider,
    public geoFenceProvider: GeoFenceProvider,
    private currentEventProvider: CurrentEventProvider
  ) {}

  ngOnInit(): void {
    // this.geoFenceProvider.readAndSendLocation();
    this.currentEventProvider.setCurrentEvent({});
    this.loadEvents();
  }

  loadEvents(): void {
    this.myEventsProvider.getMyEvents('PAST').subscribe(events => {
      this.pastEvents = events;
    });
    this.myEventsProvider.getMyEvents('UPCOMING').subscribe(events => {
      this.futureEvents = events;
    });

    this.myEventsProvider.getMyEvents('CURRENT').subscribe(events => {
      this.activeEvent = events;
      this.joinedEvents = this.activeEvent.filter(event => {
        return event.joinedOnEvent;
      });
    });
  }

  filterEvents(events: any[]): void {
    const today = new Date();
    this.futureEvents = events.filter(event => {
      return event.validFrom > today;
    });
    this.pastEvents = events.filter(event => {
      return event.validFrom < today;
    });
  }

  /**
   * Navigate to the detail page for this item.
   */
  openItem(pin: string) {
    this.navCtrl.push('EventDetailsPage', {
      pin: pin,
    });
  }

  goToEvent(pin: string, closed: boolean) {
    if (closed) {
      this.openItem(pin)
    } else {
      this.navCtrl.setRoot('EventMasterPage', {
        pin: pin
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/my-events/my-events.ts